var React = require('react');

function VxnLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M210.92 260.7L320.19 71.44H71.37L180.64 260.7a17.48 17.48 0 0030.28 0z","fill":"#eb008b","key":0}),React.createElement("path",{"d":"M177.32 104.81l-16.17 35.47h-4.9l-16.17-35.47h11.37L158.7 124l7.3-19.19zm74.16 0v35.47H248l-18.72-17.69v17.17h-9.76v-35.47H223l18.72 18v-17.48zm-35.23 57.1l-11.74 16.9 11.74 18.05h-12l-6.41-10.44-6.42 10.44h-12l12.26-17.27-12.26-17.68h12l6.94 10.59 5.89-10.59z","fill":"#fff","key":1})]);
}

VxnLogo.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 391.33 340.19"};

module.exports = VxnLogo;

VxnLogo.default = VxnLogo;
